/** Window events other features (e.g. tours) can use to drive the mobile nav drawer. */
export const NAV_EVENTS = {
  open: 'hrms:nav-open',
  close: 'hrms:nav-close',
} as const
